import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h // eslint-disable-line
import KendoBarcodeMixin from './KendoBarcodeMixin'

export default {
    name: 'kendo-barcode',
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('span')
    },
    mixins: [ KendoBarcodeMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoBarcode/index.js